import { Button, LinkButton, PublicButton } from '@yes.technology/react-toolkit'

import { ProtectedActionButton } from '../ProtectedActionButton'
import { SummaryDetailsCarouselButtonAttribution } from './SummaryDetailsCarouselContainer.types'

export {
  getButtonEntryForItem,
  getSummaryDetailsCarouselButtonAttribution
} from './utils'

export type SummaryDetailsCarouselButtonProps = {
  attribution: SummaryDetailsCarouselButtonAttribution
  onReadMore: () => void
}

const SummaryDetailsCarouselButton = ({
  attribution,
  onReadMore
}: SummaryDetailsCarouselButtonProps) => {
  if (attribution?.type === null) return null

  if (attribution?.type === 'modal') {
    const props = attribution.props
    return (
      <Button style={props?.style} onClick={onReadMore}>
        {props?.label}
      </Button>
    )
  }

  if (attribution?.type === 'link') {
    const props = attribution.props
    const href = props?.link?.url
    if (href == null) return null
    return (
      <LinkButton
        href={href}
        target={props?.link?.target ?? '_self'}
        style={props?.style}
      >
        {props?.label}
      </LinkButton>
    )
  }

  if (attribution?.type === 'individualLink') {
    const props = attribution.props
    const href = props?.link?.url
    if (href == null) return null
    return (
      <LinkButton
        href={href}
        target={props?.link?.target ?? '_self'}
        style={props?.style}
      >
        {props?.label}
      </LinkButton>
    )
  }

  if (attribution?.type === 'protected') {
    const props = attribution.props
    return (
      <ProtectedActionButton
        authenticatedRedirectUrl={props?.authenticated_redirect_url}
        signup={{
          redirectUrl: props?.signup?.redirect_url,
          buttonLabel: props?.signup?.button_label
        }}
        login={{
          redirectUrl: props?.login?.redirect_url,
          buttonLabel: props?.login?.button_label
        }}
        informationCard={props?.information_card}
      >
        <Button style={props?.style}>{props?.label}</Button>
      </ProtectedActionButton>
    )
  }

  if (attribution?.type === 'public') {
    const props = attribution.props
    const { type: _type, ...rest } = props ?? {}
    return (
      <PublicButton {...rest} onClick={onReadMore}>
        {props?.label ?? props?.children}
      </PublicButton>
    )
  }

  if (attribution?.type === 'individualPublic') {
    const props = attribution.props
    const { type: _type, link, ...rest } = props ?? {}
    return (
      <PublicButton
        {...rest}
        href={link?.url ?? props?.href}
        target={link?.target ?? props?.target ?? '_self'}
      >
        {props?.label ?? props?.children}
      </PublicButton>
    )
  }

  return null
}

export default SummaryDetailsCarouselButton
